import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./MenuCuerpo.css";

import { useNavigate } from "react-router-dom";

import FooterCorp from "../modulos/footerCorp";
import obtieneDatos from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

// ============================================================
// CADETES
// ============================================================

import Cadetes from "../NCadetes/Cadetes";
import ModuloGeneraPresenteAdicional from "../NCadetes/ModuloGeneraPresenteAdicional";
import Listado from "../NCadetes/Listado";
import PasesDeSalida from "../NCadetes/PasesDeSalida";
import GenerarPaseEspecial from "../NCadetes/GenerarPaseEspecial";
import CarpetaMedica from "../NCadetes/CarpetaMedica";

// ============================================================
// CUERPO
// ============================================================

import GuardiaForm from "./GuardiaForm";
import GuardiaComponentFecha from "./GuardiaComponentFecha";
import DevuelveAvisos from "./DevuelveAvisos";

// ============================================================
// GUARDIA / ESTUDIOS
// ============================================================

import MuestraEstadosDivisiones from "../Estudios/MuestraEstadosDivisiones";

// ============================================================
// NUEVO - AVISOS INTERNOS MASIVOS
// ============================================================

import CreaAvisosInternosMasivos from "../NCadetes/CreaAvisosInternosMasivos";

// ============================================================
// COMPONENTE
// ============================================================


// Shadow DOM: aísla el formulario del CSS global sin perder sus estilos.
const FormularioPermisoAislado = ({ onClose }) => {
  const [raiz, setRaiz] = useState(null);

  const conectarRaiz = (elemento) => {
    if (!elemento) return;
    setRaiz((anterior) => anterior || elemento.shadowRoot || elemento.attachShadow({ mode: "open" }));
  };

  return (
    <div
      ref={conectarRaiz}
      style={{ display: "block", width: "100%", minHeight: 0 }}
    >
      {raiz && createPortal(
        <>
          <style>{`
            :host { display: block; width: 100%; color: #212529; font-family: Arial, sans-serif; }
            *, *::before, *::after { box-sizing: border-box; }
            .permiso-contenedor { width: 100%; padding: 22px 26px 28px; background: #fff; }
            .iseps-permiso-especial { display: block !important; width: 100% !important; max-width: 620px !important; margin: 0 auto !important; padding: 0 !important; color: #212529 !important; font-family: Arial, sans-serif !important; }
            .iseps-permiso-especial h5 { display: block !important; font-size: 19px !important; font-weight: 700 !important; margin: 0 0 16px !important; }
            .iseps-permiso-aviso { display: block !important; width: 100% !important; margin: 0 0 18px !important; padding: 14px 16px !important; background: #e6f7ff !important; border: 1px solid #a6e0f5 !important; border-radius: 8px !important; color: #17445b !important; font-size: 14px !important; line-height: 1.5 !important; }
            .iseps-permiso-form { display: flex !important; flex-direction: column !important; align-items: stretch !important; gap: 16px !important; width: 100% !important; margin: 0 !important; }
            .iseps-permiso-form > div { display: flex !important; flex-direction: column !important; align-items: stretch !important; gap: 7px !important; width: 100% !important; min-width: 0 !important; }
            .iseps-permiso-label { display: block !important; width: 100% !important; font-size: 14px !important; font-weight: 600 !important; color: #343a40 !important; }
            .iseps-permiso-control { display: block !important; width: 100% !important; min-width: 0 !important; min-height: 44px !important; padding: 10px 12px !important; border: 1px solid #ced4da !important; border-radius: 8px !important; background: #fff !important; color: #212529 !important; font: 15px Arial, sans-serif !important; }
            .iseps-permiso-control:focus { outline: 2px solid #86b7fe !important; outline-offset: 1px !important; }
            textarea.iseps-permiso-control { min-height: 100px !important; resize: vertical !important; }
            .iseps-permiso-form > div:last-child { flex-direction: row !important; flex-wrap: wrap !important; gap: 10px !important; margin-top: 8px !important; }
            .iseps-permiso-boton { display: inline-block !important; width: auto !important; padding: 11px 16px !important; border-radius: 8px !important; font-size: 14px !important; font-weight: 600 !important; cursor: pointer !important; }
            .iseps-permiso-boton-primario { background: #0d6efd !important; color: white !important; border: 1px solid #0d6efd !important; }
            .iseps-permiso-boton-secundario { background: #fff !important; color: #343a40 !important; border: 1px solid #6c757d !important; }
            .iseps-permiso-boton:disabled { opacity: .6 !important; cursor: not-allowed !important; }
            @media(max-width: 600px) { .permiso-contenedor { padding: 16px; } }
          `}</style>
          <div className="permiso-contenedor">
            <GenerarPaseEspecial onClose={onClose} />
          </div>
        </>,
        raiz
      )}
    </div>
  );
};

const CuerpoMenu = () => {
  const navigate = useNavigate();

  const Usuario = obtieneDatos();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [selectedComponent, setSelectedComponent] = useState("cadetes");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mostrarModalPermisoEspecial, setMostrarModalPermisoEspecial] = useState(false);

  const [fecha, setFecha] = useState("");

  const [sede, setSede] = useState("");

  const [mostrarCargaGuardia, setMostrarCargaGuardia] = useState(true);

  const [mostrarConsultaGuardia, setMostrarConsultaGuardia] =
    useState(true);

  const [mostrarAvisosInternos, setMostrarAvisosInternos] =
    useState(true);

  // ============================================================
  // CONTROL DE USUARIO
  // ============================================================

  useEffect(() => {
    if (!Usuario?.id) {
      alert("Acceso no autorizado");
      navigate("/");
    }
  }, [Usuario?.id, navigate]);

  // ============================================================
  // PERMISOS
  // ============================================================

  const puedeGestionarGuardias =
    Usuario?.destino == 7 ||
    comprueboPermisos(Usuario?.funcion, "Carga Guardias");

  // ============================================================
  // SEDE AUTOMÁTICA
  // ============================================================

  useEffect(() => {
    if (Usuario?.sedeID == 2) {
      setSede("Rosario");
    }

    if (Usuario?.sedeID == 3) {
      setSede("Recreo");
    }
  }, [Usuario?.sedeID]);

  // ============================================================
  // MENU
  // ============================================================

  const handleMenuClick = (component) => {
    setSelectedComponent(component);

    setIsMenuOpen(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleMenu = () => {
    setIsMenuOpen((anterior) => !anterior);
  };

  // ============================================================
  // COMPONENTE CADETES
  // ============================================================

  const renderCadetes = () => {
    return (
      <div className="cuerpo-section">
        <Cadetes />
      </div>
    );
  };

  // ============================================================
  // PRESENTES
  // ============================================================

  const renderPresentes = () => {
    return (
      <div className="cuerpo-section">
        {/* PRESENTE MANUAL */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h3 style={styles.cardTitle}>Presentes manuales</h3>

              <p style={styles.cardDescription}>
                Registre manualmente la presencia de un cadete.
              </p>
            </div>

            <div style={styles.iconBox}>✓</div>
          </div>

          <ModuloGeneraPresenteAdicional
            pasado={() => socket.emit("creaPresenteCadete", [])}
          />
        </div>

        {/* LISTADO */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h3 style={styles.cardTitle}>
                Presentes y novedades
              </h3>

              <p style={styles.cardDescription}>
                Consulte los cadetes presentados y las novedades del
                día.
              </p>
            </div>
          </div>

          <Listado />
        </div>
      </div>
    );
  };

  // ============================================================
  // PASES
  // ============================================================

  const renderPases = () => {
    return (
      <div className="cuerpo-section">
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h3 style={styles.cardTitle}>Pases de salida</h3>

              <p style={styles.cardDescription}>
                Gestión de pases de salida de cadetes.
              </p>
            </div>
          </div>

          <div
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <PasesDeSalida />
          </div>
        </div>
      </div>
    );
  };

  // ============================================================
  // GUARDIAS E INTERNOS
  // ============================================================

  const renderGuardiasInternos = () => {
    if (!puedeGestionarGuardias) {
      return (
        <div style={styles.card}>
          <div style={styles.noPermission}>
            <h3>Acceso restringido</h3>

            <p>
              No posee permisos para gestionar Guardias e Internos.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="cuerpo-section">
        {/* ==================================================== */}
        {/* CABECERA */}
        {/* ==================================================== */}

        <div style={styles.pageHeader}>
          <div>
            <h2 style={styles.pageTitle}>Guardias e Internos</h2>

            <p style={styles.pageSubtitle}>
              Gestión de guardias, consultas e internos de cadetes.
            </p>
          </div>

          <div style={styles.userSiteBadge}>
            {Usuario?.sedeID == 1
              ? "Todas las sedes"
              : Usuario?.sedeID == 2
              ? "Rosario"
              : Usuario?.sedeID == 3
              ? "Recreo"
              : "Sede"}
          </div>
        </div>

        {/* ==================================================== */}
        {/* MENÚ INTERNO */}
        {/* ==================================================== */}

        <div style={styles.internalTabs}>
          <button
            type="button"
            style={{
              ...styles.internalTab,
              ...(mostrarCargaGuardia
                ? styles.internalTabActive
                : {}),
            }}
            onClick={() => {
              setMostrarCargaGuardia(true);
              setMostrarConsultaGuardia(false);
              setMostrarAvisosInternos(false);
            }}
          >
            Cargar guardias
          </button>

          <button
            type="button"
            style={{
              ...styles.internalTab,
              ...(mostrarConsultaGuardia
                ? styles.internalTabActive
                : {}),
            }}
            onClick={() => {
              setMostrarCargaGuardia(false);
              setMostrarConsultaGuardia(true);
              setMostrarAvisosInternos(false);
            }}
          >
            Consultar guardias
          </button>

          <button
            type="button"
            style={{
              ...styles.internalTab,
              ...(mostrarAvisosInternos
                ? styles.internalTabActive
                : {}),
            }}
            onClick={() => {
              setMostrarCargaGuardia(false);
              setMostrarConsultaGuardia(false);
              setMostrarAvisosInternos(true);
            }}
          >
            Crear internos
          </button>
        </div>

        {/* ==================================================== */}
        {/* CARGAR GUARDIAS */}
        {/* ==================================================== */}

        {mostrarCargaGuardia && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h3 style={styles.cardTitle}>
                  Cargar guardias de cadetes
                </h3>

                <p style={styles.cardDescription}>
                  Asigne las guardias correspondientes a los
                  cadetes.
                </p>
              </div>

              <div style={styles.iconBox}>G</div>
            </div>

            <div style={styles.cardBody}>
              <GuardiaForm />
            </div>
          </div>
        )}

        {/* ==================================================== */}
        {/* CONSULTAR GUARDIAS */}
        {/* ==================================================== */}

        {mostrarConsultaGuardia && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h3 style={styles.cardTitle}>
                  Ver guardias e internos
                </h3>

                <p style={styles.cardDescription}>
                  Seleccione fecha y sede para consultar la
                  información.
                </p>
              </div>

              <div style={styles.iconBox}>🔎</div>
            </div>

            <div style={styles.filtersContainer}>
              {/* FECHA */}

              <div style={styles.filterGroup}>
                <label style={styles.label}>Fecha</label>

                <input
                  type="date"
                  value={fecha}
                  onChange={(e) => setFecha(e.target.value)}
                  style={styles.input}
                />
              </div>

              {/* SEDE */}

              <div style={styles.filterGroup}>
                <label style={styles.label}>Sede</label>

                <select
                  value={sede}
                  onChange={(e) => setSede(e.target.value)}
                  style={styles.input}
                  disabled={Usuario?.sedeID == 2 || Usuario?.sedeID == 3}
                >
                  <option value="">Seleccione una sede</option>

                  {Usuario?.sedeID == 1 && (
                    <>
                      <option value="Rosario">Rosario</option>

                      <option value="Recreo">Recreo</option>
                    </>
                  )}

                  {Usuario?.sedeID == 2 && (
                    <option value="Rosario">Rosario</option>
                  )}

                  {Usuario?.sedeID == 3 && (
                    <option value="Recreo">Recreo</option>
                  )}
                </select>
              </div>
            </div>

            {/* RESULTADO */}

            {!fecha || !sede ? (
              <div style={styles.emptyState}>
                Seleccione una fecha y una sede para visualizar las
                guardias e internos.
              </div>
            ) : (
              <div style={styles.resultContainer}>
                <GuardiaComponentFecha
                  fecha={fecha}
                  sede={sede}
                />
              </div>
            )}
          </div>
        )}

        {/* ==================================================== */}
        {/* NUEVO - CREAR INTERNOS */}
        {/* ==================================================== */}

        {mostrarAvisosInternos && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div>
                <h3 style={styles.cardTitle}>
                  Crear avisos de interno
                </h3>

                <p style={styles.cardDescription}>
                  Seleccione uno o más cadetes presentes y las fechas
                  en las que permanecerán como internos.
                </p>
              </div>

              <div style={styles.iconBox}>I</div>
            </div>

            {/* ================================================= */}
            {/* USUARIO CON TODAS LAS SEDES */}
            {/* ================================================= */}

            {Usuario?.sedeID == 1 && (
              <>
                <div style={styles.siteSelectorBox}>
                  <div style={styles.filterGroup}>
                    <label style={styles.label}>
                      Sede para los avisos
                    </label>

                    <select
                      value={sede}
                      onChange={(e) => setSede(e.target.value)}
                      style={styles.input}
                    >
                      <option value="">
                        Seleccione una sede
                      </option>

                      <option value="Rosario">Rosario</option>

                      <option value="Recreo">Recreo</option>
                    </select>
                  </div>
                </div>

                {sede ? (
                  <CreaAvisosInternosMasivos sede={sede} />
                ) : (
                  <div style={styles.emptyState}>
                    Seleccione primero la sede para comenzar.
                  </div>
                )}
              </>
            )}

            {/* ================================================= */}
            {/* ROSARIO */}
            {/* ================================================= */}

            {Usuario?.sedeID == 2 && (
              <CreaAvisosInternosMasivos sede="Rosario" />
            )}

            {/* ================================================= */}
            {/* RECREO */}
            {/* ================================================= */}

            {Usuario?.sedeID == 3 && (
              <CreaAvisosInternosMasivos sede="Recreo" />
            )}
          </div>
        )}
      </div>
    );
  };

  // ============================================================
  // RECONOCIMIENTOS
  // ============================================================

  const renderReconocimientos = () => {
    return (
      <div className="cuerpo-section">
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h3 style={styles.cardTitle}>Reconocimientos</h3>

              <p style={styles.cardDescription}>
                Gestión de carpetas médicas y reconocimientos.
              </p>
            </div>
          </div>

          <CarpetaMedica />
        </div>
      </div>
    );
  };

  // ============================================================
  // DIVISIONES
  // ============================================================

  const renderDivisiones = () => {
    return (
      <div className="cuerpo-section">
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h3 style={styles.cardTitle}>
                Estado de divisiones
              </h3>

              <p style={styles.cardDescription}>
                Información actual de divisiones y cadetes.
              </p>
            </div>
          </div>

          <MuestraEstadosDivisiones />
        </div>
      </div>
    );
  };

  // ============================================================
  // AVISOS
  // ============================================================

  const renderAvisos = () => {
    return (
      <div className="cuerpo-section">
        <div style={styles.pageHeader}>
          <div>
            <h2 style={styles.pageTitle}>Avisos</h2>

            <p style={styles.pageSubtitle}>
              Avisos y novedades correspondientes a cada sede.
            </p>
          </div>
        </div>

        {Usuario?.sedeID == 1 && (
          <>
            <div style={styles.card}>
              <div style={styles.siteTitle}>Rosario</div>

              <DevuelveAvisos sede="Rosario" />
            </div>

            <div style={styles.card}>
              <div style={styles.siteTitle}>Recreo</div>

              <DevuelveAvisos sede="Recreo" />
            </div>
          </>
        )}

        {Usuario?.sedeID == 2 && (
          <div style={styles.card}>
            <DevuelveAvisos sede="Rosario" />
          </div>
        )}

        {Usuario?.sedeID == 3 && (
          <div style={styles.card}>
            <DevuelveAvisos sede="Recreo" />
          </div>
        )}
      </div>
    );
  };

  // ============================================================
  // RENDER COMPONENTE ACTUAL
  // ============================================================

  const renderContenido = () => {
    switch (selectedComponent) {
      case "cadetes":
        return renderCadetes();

      case "presentes":
        return renderPresentes();

      case "pases":
        return renderPases();

      case "guardias":
        return renderGuardiasInternos();

      case "reconocimientos":
        return renderReconocimientos();

      case "divisiones":
        return renderDivisiones();

      case "avisos":
        return renderAvisos();

      default:
        return renderCadetes();
    }
  };

  // ============================================================
  // RETURN
  // ============================================================

  return (
    <div className="menu-container">
      {/* ====================================================== */}
      {/* MENU SUPERIOR */}
      {/* ====================================================== */}

      <nav className="menuCuerpo">
        <div
          className="hamburger"
          onClick={toggleMenu}
          role="button"
          tabIndex={0}
        >
          ☰
        </div>

        <div className={`menu-items ${isMenuOpen ? "open" : ""}`}>
          <div
            className={`menu-item ${
              selectedComponent === "cadetes" ? "active" : ""
            }`}
            onClick={() => handleMenuClick("cadetes")}
          >
            Cadetes
          </div>

          <div
            className={`menu-item ${
              selectedComponent === "presentes" ? "active" : ""
            }`}
            onClick={() => handleMenuClick("presentes")}
          >
            Presentes y Partes
          </div>

          <div
            className={`menu-item ${
              selectedComponent === "pases" ? "active" : ""
            }`}
            onClick={() => handleMenuClick("pases")}
          >
            Pases de Salida
          </div>

          <div
            className={`menu-item ${
              mostrarModalPermisoEspecial ? "active" : ""
            }`}
            onClick={() => {
              setIsMenuOpen(false);
              setMostrarModalPermisoEspecial(true);
            }}
          >
            Permisos Especiales
          </div>

          {puedeGestionarGuardias && (
            <div
              className={`menu-item ${
                selectedComponent === "guardias" ? "active" : ""
              }`}
              onClick={() => handleMenuClick("guardias")}
            >
              Guardias e Internos
            </div>
          )}

          <div
            className={`menu-item ${
              selectedComponent === "reconocimientos"
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleMenuClick("reconocimientos")
            }
          >
            Reconocimientos
          </div>

          <div
            className={`menu-item ${
              selectedComponent === "divisiones" ? "active" : ""
            }`}
            onClick={() => handleMenuClick("divisiones")}
          >
            Divisiones
          </div>

          <div
            className={`menu-item ${
              selectedComponent === "avisos" ? "active" : ""
            }`}
            onClick={() => handleMenuClick("avisos")}
          >
            Avisos
          </div>

          <div
            className="menu-item menu-item-volver"
            onClick={() => navigate("/usuarioLogueado")}
          >
            Volver
          </div>
        </div>
      </nav>

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <style>{`
        .iseps-modal-overlay { position: fixed !important; inset: 0 !important; z-index: 99999 !important; display: flex !important; justify-content: center !important; align-items: center !important; padding: 16px !important; background: rgba(0,0,0,.6) !important; }
        .iseps-modal-dialog { display: flex !important; flex-direction: column !important; width: min(760px, 100%) !important; max-width: 760px !important; max-height: calc(100dvh - 32px) !important; margin: auto !important; overflow: hidden !important; border-radius: 14px !important; background: white !important; }
        .iseps-modal-header { display: flex !important; flex-direction: row !important; justify-content: space-between !important; align-items: flex-start !important; flex-shrink: 0 !important; width: 100% !important; padding: 18px 22px !important; background: #212529 !important; color: #fff !important; }
        .iseps-modal-body { display: block !important; flex: 1 1 auto !important; min-height: 0 !important; width: 100% !important; padding: 20px !important; overflow-y: auto !important; overflow-x: hidden !important; background: #fff !important; }
      `}</style>
      {mostrarModalPermisoEspecial && createPortal(
        <div
          role="presentation"
          className="iseps-modal-overlay" style={styles.modalOverlay}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              setMostrarModalPermisoEspecial(false);
            }
          }}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="tituloPermisoEspecial"
            className="iseps-modal-dialog" style={styles.modalDialog}
          >
            <div className="iseps-modal-header" style={styles.modalHeader}>
              <div>
                <h3 id="tituloPermisoEspecial" style={{ margin: 0 }}>
                  Generar permiso especial
                </h3>
                <p style={{ margin: "5px 0 0", fontSize: "13px", opacity: 0.85 }}>
                  Para cadetes de franco, sin registrar presente. Estado inicial: Pendiente.
                </p>
              </div>
              <button
                type="button"
                aria-label="Cerrar permiso especial"
                className="btn btn-sm btn-light"
                onClick={() => setMostrarModalPermisoEspecial(false)}
              >
                ✕
              </button>
            </div>
            <div className="iseps-modal-body" style={{ padding: 0, overflowY: "auto", overflowX: "hidden", minHeight: 0, flex: "1 1 auto", background: "#fff" }}>
              <FormularioPermisoAislado
                onClose={() => setMostrarModalPermisoEspecial(false)}
              />
            </div>
          </div>
        </div>,
        document.body
      )}

      <main className="component-display">
        {renderContenido()}

        <div className="footer">
          <FooterCorp />
        </div>
      </main>
    </div>
  );
};

export default CuerpoMenu;

// ============================================================
// ESTILOS INTERNOS
// ============================================================

const styles = {
  modalOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    background: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },
  modalDialog: {
    background: "#fff",
    width: "100%",
    maxWidth: "760px",
    maxHeight: "calc(100vh - 32px)",
    borderRadius: "14px",
    boxShadow: "0 18px 60px rgba(0, 0, 0, 0.25)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  modalHeader: {
    background: "#212529",
    color: "white",
    padding: "18px 22px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
  },
  modalBody: {
    padding: "20px",
    overflowY: "auto",
    minHeight: 0,
    display: "block",
    background: "#ffffff",
  },
  pageHeader: {
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
    marginBottom: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    flexWrap: "wrap",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
  },

  pageTitle: {
    margin: 0,
    fontSize: "25px",
    fontWeight: 700,
  },

  pageSubtitle: {
    margin: "5px 0 0 0",
    color: "#6b7280",
    fontSize: "14px",
  },

  userSiteBadge: {
    padding: "8px 14px",
    borderRadius: "20px",
    background: "#f1f3f5",
    fontSize: "13px",
    fontWeight: 600,
  },

  card: {
    width: "calc(100% - 20px)",
    maxWidth: "1200px",
    boxSizing: "border-box",
    margin: "10px auto 20px auto",
    padding: "20px",
    borderRadius: "14px",
    border: "1px solid #e2e5e9",
    background: "#ffffff",
    boxShadow: "0 3px 14px rgba(0,0,0,0.06)",
  },

  cardHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    paddingBottom: "15px",
    marginBottom: "15px",
    borderBottom: "1px solid #ececec",
  },

  cardTitle: {
    margin: 0,
    fontSize: "19px",
    fontWeight: 700,
  },

  cardDescription: {
    margin: "5px 0 0 0",
    color: "#6b7280",
    fontSize: "14px",
  },

  cardBody: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  iconBox: {
    minWidth: "38px",
    height: "38px",
    borderRadius: "10px",
    background: "#f1f3f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  },

  internalTabs: {
    width: "calc(100% - 20px)",
    maxWidth: "1200px",
    margin: "0 auto 15px auto",
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },

  internalTab: {
    border: "1px solid #d8dce1",
    background: "#ffffff",
    padding: "10px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
  },

  internalTabActive: {
    background: "#212529",
    color: "#ffffff",
    borderColor: "#212529",
  },

  filtersContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: "15px",
    flexWrap: "wrap",
    marginBottom: "20px",
  },

  filterGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    minWidth: "230px",
  },

  label: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#444",
  },

  input: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "8px",
    border: "1px solid #ced4da",
    padding: "11px",
    fontSize: "15px",
    background: "#ffffff",
  },

  siteSelectorBox: {
    maxWidth: "400px",
    margin: "0 auto 20px auto",
  },

  resultContainer: {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #e1e3e5",
    borderRadius: "10px",
    padding: "10px",
    overflowX: "auto",
  },

  emptyState: {
    width: "100%",
    boxSizing: "border-box",
    padding: "30px 15px",
    textAlign: "center",
    color: "#777",
    background: "#f8f9fa",
    borderRadius: "10px",
  },

  noPermission: {
    textAlign: "center",
    padding: "30px",
    color: "#666",
  },

  siteTitle: {
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "12px",
  },
};